module.exports = __webpack_public_path__ + "media/directory/filter_sign-c470453c.svg";